module.exports = __webpack_public_path__ + "img/ptu-2.7aef35d1.png";